// extracted by mini-css-extract-plugin
module.exports = {"columns-3":"1700","columns-2":"1550","columns-1":"1350","invalid":"CountryPrefixInput_invalid__2-sOK"};